import { render, staticRenderFns } from "./oilcrossreference.vue?vue&type=template&id=c19d15dc&"
import script from "./oilcrossreference.vue?vue&type=script&lang=js&"
export * from "./oilcrossreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports